import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=3d450a36&scoped=true"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=3d450a36&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d450a36",
  null
  
)

export default component.exports